
import {Component, Vue, Watch} from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {
  IProcessedTaskChilds,
  IslemDurum,
  ITask,
  PlayerDurum
} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import {gorevDurumEtiketi} from "@/plugins/uyap-plugin/store/modules/gorevDurumEtiketi";
import {TaskTuru, TaskTuruLabel} from "@/plugins/uyap-plugin/enum/TaskTuru";
import Draggable from "vuedraggable";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {UYAP_ENGEL_METINLERI} from "@/utils/uyapEngel";

@Component({
  computed: {
    IslemDurum(){
      return IslemDurum;
    }
  },
  components: {DeleteDialog, Draggable}
})

export default class DevamEdenGorevList extends Vue {
  taskDurum = TaskDurum;

  /**
   * kod inceleme: "Zamanlanmış" (saati gelmedi) → "saati geldi" geçişi zamana
   * bağlı ama `new Date()` reaktif DEĞİL; bu alan olmadan liste, kuyruk
   * değişmediği (ör. socket 'updateTasks') sürece geçmiş saatte "Zamanlanmış"
   * göstermeye devam ederdi (SorguKaynakRozeti.vue'daki suAn deseniyle aynı
   * gerekçe). Yalnız listede scheduled_at'i gelecekte olan bir görev VARKEN
   * çalışır; öyle bir görev kalmayınca `zamanlanmisGorevVarMi` izleyicisi
   * zamanlayıcıyı durdurur.
   */
  private suAn: Date = new Date();
  private suAnAraligi: number | null = null;

  // Sırada görünen görev saatini bekliyor mu, saati geçmiş mi, düz sırada mı
  // (bkz. gorevDurumEtiketi.ts). Şablonda üç kez okunur; saf ve ucuz.
  durumEtiketi(item: {status: number, scheduled_at?: any}) {
    return gorevDurumEtiketi(item.status, item.scheduled_at ?? null, this.suAn);
  }

  get zamanlanmisGorevVarMi(): boolean {
    return this.tasks.some((task) => this.durumEtiketi(task).tur === "zamanlanmis");
  }

  @Watch("zamanlanmisGorevVarMi", {immediate: true})
  private zamanlanmisGorevVarMiDegisti(varMi: boolean) {
    if (varMi && this.suAnAraligi === null) {
      this.suAnAraligi = window.setInterval(() => {
        this.suAn = new Date();
      }, 30 * 1000);
    } else if (!varMi && this.suAnAraligi !== null) {
      clearInterval(this.suAnAraligi);
      this.suAnAraligi = null;
    }
  }

  beforeDestroy() {
    if (this.suAnAraligi !== null) {
      clearInterval(this.suAnAraligi);
    }
  }

  taskTuru = TaskTuru;
  taskTuruLabel = TaskTuruLabel;
  playerDurum = PlayerDurum;
  duraklatildiIpucu = UYAP_ENGEL_METINLERI.duraklatildiIpucu;

  /** Panelin bildiği herhangi bir UYAP engeli (panel kilidi ya da botun engeli) var mı? */
  get uyapEngeliAktif(): boolean {
    return this.$store.getters.uyapEngeliAktif === true;
  }

  /**
   * Oto moddayız ama işlenecek yerel görev yok: bot kapalı değil, BEKLİYOR.
   * Kullanıcı boş listeye bakıp "çalışmıyor" sanmasın diye açıkça yazılır.
   */
  get bosKuyruktaBekleniyor(): boolean {
    return this.tasks.length === 0
        && this.$store.getters.getPlayerDurum === PlayerDurum.oto;
  }
  onFly = false;
  isDeleteModeActive = false;
  deleting = false;
  silinecekTasks = [];
  startingTask = false;
  headers = [
    {text: "", value: "drag"},
    {text: "Görev Türü", value: "islemTuru"},
    {text: "Açıklama", value: "aciklama"},
    {text: "Oluşturulma Tarihi", value: "created_at"},
    {text: "Durum", value: "durum", sortable: false, align: 'center'},
    {text: "İşlemler", class: "sticky-header", value: "actions", width: '90', sortable: false, align: 'center'},
  ];

  get showProgressBar() {
    return this.$store.getters.getChildTasksStatus.length > 0 || this.startingTask;
  }

  get tamamlanmaDurumu() {
    if (this.startingTask) return 0;
    let bitendosyalar = this.$store.getters.getChildTasksStatus.filter((child: IProcessedTaskChilds) => [TaskDurum.BITTI_BASARILI, TaskDurum.BITTI_HATALI, TaskDurum.BITTI_EKSIK, TaskDurum.YENIDEN_BASLATILDI].indexOf(child.status) != -1);
    let yuzde = (100 / this.$store.getters.getChildTasksStatus.length) * bitendosyalar.length;
    return yuzde;
  }

  get progressMessage() {
    if (this.startingTask) {
      return "Görev başlatılıyor...";
    }
    let bitendosyalar = this.$store.getters.getChildTasksStatus.filter((child: IProcessedTaskChilds) => [TaskDurum.BITTI_BASARILI, TaskDurum.BITTI_HATALI, TaskDurum.BITTI_EKSIK, TaskDurum.YENIDEN_BASLATILDI].indexOf(child.status) != -1);
    return "Görevler üzerinde çalışılıyor... (" + bitendosyalar.length + "/" + this.$store.getters.getChildTasksStatus.length + ")";
  }

  get tasks(): Array<ITask> {
    return this.$store.getters.getSiradakiGorevler;
  }

  get dragOptions() {
    return {
      animation: 200,
      group: "description",
      disabled: false,
      ghostClass: "ghost"
    };
  }

  get disableDrag() {
    return !!this.tasks.find(task => task.status == TaskDurum.ISLENIYOR) || this.onFly;
  }

  onDelete(task: ITask) {
    this.$store.dispatch('deleteAllTasks', task);
  }

  async onDeleteMultiple() {
    try {
      this.deleting = true;
      this.isDeleteModeActive = false;
      await this.$http.post('/api/v1/task/toplu-sil', {tasks_ids: this.silinecekTasks.map((item: ITask) => item.id)});
      this.silinecekTasks = [];
    } catch (e) {
      this.$toast.error('Silme işleminde hata oluştu. ' + e.message);
    } finally {
      await this.$store.dispatch('getTasksFromServer');
      this.deleting = false;
    }
  }

  onEnd(evt: any) {
    if (evt.oldIndex == evt.newIndex)
      return;
    this.onFly = true;
    let liste = [...this.tasks];
    let changedElement = liste[evt.oldIndex];
    changedElement.oncelik_sirasi = evt.newIndex + 1;
    liste.splice(evt.oldIndex, 1);
    if (evt.oldIndex > evt.newIndex) {
      for (let i = evt.newIndex; i < liste.length; i++) {
        liste[i].oncelik_sirasi = i + 2;
      }
    } else if (evt.oldIndex < evt.newIndex) {
      for (let i = evt.newIndex - 1; i >= 0; i--) {
        liste[i].oncelik_sirasi = i + 1;
      }
    }
    liste.push(changedElement);
    liste.sort((a, b) => (a.oncelik_sirasi - b.oncelik_sirasi));
    this.$http.post('/api/v1/task/onceliksirasi', liste).then(() => {
      this.$socket.client.emit("updateTasks");
      this.onFly = false;
    });
  }

  async durdurDevamEt() {
    // İmza bağlantısı kontrol et
    if (!this.$store.getters.isImzaConnected) {
      this.$toast.warning('İmza Bağlantısı Kurulunuz. Lütfen sağ üstteki İmza simgesine tıklayınız.');
      return;
    }

    // Durdur: UYAP bağlantısı aranmaz (DEV-3898). UYAP düşünce bot player 'oto'da kalıp
    // yeniden bağlanmayı dener; kullanıcı bunu bağlantı gelmeden de durdurabilmelidir.
    if (this.$store.getters.getPlayerDurum == this.playerDurum.oto) {
      this.$socket.client.emit("player", this.playerDurum.durduruluyor);
      this.$toast.info('Görevler durduruluyor...');
    } else {
      // Başlat: UYAP bağlantısı kontrol et
      if (!this.$store.getters.isUyapConnected) {
        this.$toast.warning('UYAP Bağlantısı Kurulunuz. Lütfen sağ üstteki UYAP simgesine tıklayınız.');
        return;
      }

      // K5 (DEV-3572): UYAP engeli biliniyorsa (panelin kaydı ya da sunucudaki açık engel) önce onay istenir
      // (Vazgeç -> hiçbir şey yayınlanmaz); kilit/fren kaldırma ve 'oto' yayını action'da. Tek geçit: playerBaslatOnayli.
      const basladi = await this.$store.dispatch('playerBaslatOnayli', this.$socket.client);
      if (!basladi) return;
      this.startingTask = true;
      this.$toast.success('Görevler başlatılıyor...');
      // 3 saniye sonra loading state'i kapat
      await new Promise(resolve => setTimeout(resolve, 3000));
      this.startingTask = false;
    }
  }

  detayaGit(task: ITask) {
    switch (task.task_type_id) {
      case this.taskTuru.takip_hazirla:
        this.$router.push(ProgramPaths.eicrapro + '/takip-hazirla-detay/' + task.id);
        break;
      case this.taskTuru.hizli_takip_ac:
      case this.taskTuru.takip_ac:
        this.$router.push(ProgramPaths.eicrapro + '/takip-ac-detay/' + task.id);
        break;
      case this.taskTuru.mts_takip_hazirla:
        this.$router.push(ProgramPaths.eicrapro + '/mts-takip-hazirla-beta-detay/' + task.id);
        break;
      case this.taskTuru.eski_mts_hizli_takip_ac:
        this.$router.push(ProgramPaths.eicrapro + '/mts-takip-hazirla-detay/' + task.id);
        break;
      case this.taskTuru.mts_hizli_takip_ac:
      case this.taskTuru.mts_takip_ac:
        this.$router.push(ProgramPaths.eicrapro + '/mts-takip-ac-detay/' + task.id);
        break;
      case this.taskTuru.takip_sorgula:
        this.$router.push(ProgramPaths.eicrapro + '/takip-sorgula-detay/' + task.id);
        break;
      case this.taskTuru.evrak_gonder:
        this.$router.push(ProgramPaths.eicrapro + '/evrak-gonder-detay/' + task.id);
        break;
      case this.taskTuru.hazir_evrak_gonder:
        this.$router.push(ProgramPaths.eicrapro + '/hazir-evrak-gonder-detay/' + task.id);
        break;
      case this.taskTuru.makbuz_indir:
        this.$router.push(ProgramPaths.eicrapro + '/makbuz-indir-detay/' + task.id);
        break;
      case this.taskTuru.toplu_genel_talep_hazirla:
        this.$router.push(ProgramPaths.eicrapro + '/genel-talep-gonder-detay/' + task.id);
        break;
      case this.taskTuru.toplu_tebligat_hazirla:
        this.$router.push(ProgramPaths.eicrapro + '/tebligat-gonder-detay/' + task.id);
        break;
      case this.taskTuru.toplu_haciz_gonder:
        this.$router.push(ProgramPaths.eicrapro + '/haciz-gonder-detay/' + task.id);
        break;
      case this.taskTuru.harc_masraf_ode:
        this.$router.push(ProgramPaths.eicrapro + '/harc-masraf-ode-detay/' + task.id);
        break;
      case this.taskTuru.mts_odeme:
        this.$router.push(ProgramPaths.eicrapro + '/mts-ode-detay/' + task.id);
        break;
      case this.taskTuru.mts_tebligat_gonder:
        this.$router.push(ProgramPaths.eicrapro + '/mts-tebligat-gonder-detay/' + task.id);
        break;
      case this.taskTuru.evrak_indir:
        this.$router.push(ProgramPaths.eicrapro + '/evrak-indir-detay/' + task.id);
        break;
    }
  }
}
